const request = {
    invalid_input: '输入无效。{{details}}',
    general: '发生请求错误。',
    /** UNTRANSLATED */
    range_not_satisfiable: 'Range not satisfiable.',
    /** UNTRANSLATED */
    too_many_requests: 'Too many requests.',
};
export default Object.freeze(request);
